import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var enrollCourseApprovalRes;
export const enrollCourseApprovalTodo = createAsyncThunk('enrollCourseApproval', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    // console.log(val)

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/update_approval',
            data: {
                "user_id": val.data.user_id,
                "user_role": user_id.vrole_name,
                "course_id": val.data.course_id,
                "approved_by": user_id.vemp_code,
                "approval_status": val.status,
                "course_approval_id": val.data.id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return enrollCourseApprovalRes = res.data
    } catch (error) {
        return enrollCourseApprovalRes = error.response.data
    }
})